import P from "prop-types";
import * as S from "./styles";

export function Pesquisa({ pesquisa }) {
  return (
    <S.Container>
      <a href={pesquisa.link} target="_blank" rel="noreferrer">
        {pesquisa.titulo}
      </a>
      <S.Categorias>
        {pesquisa.categorias.map((categoria, index) => (
          <span key={index}>{categoria}</span>
        ))}
      </S.Categorias>
      <S.Autores>{pesquisa.autores}</S.Autores>
      <S.Revista>
        {pesquisa.revista}, {pesquisa.ano}
      </S.Revista>
      <S.PalavrasChave>
        <p>
          palavras-chave: <i>{pesquisa.palavras_chave}</i>
        </p>
      </S.PalavrasChave>
    </S.Container>
  );
}

Pesquisa.propTypes = {
  pesquisa: P.shape({
    titulo: P.string.isRequired,
    categorias: P.arrayOf(P.string).isRequired,
    autores: P.arrayOf(P.string).isRequired,
    revista: P.string.isRequired,
    palavras_chave: P.string.isRequired,
    ano: P.number.isRequired,
    link: P.string.isRequired,
  }),
};
